import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import {
  DocumentGroup,
  DocumentItemIcon,
  DocumentMatrix,
  DocumentRange,
  DocumentRequirementsService,
} from '../../services/document-requirements.service';
import { selectRangeForAmount } from '../../utils/document-requirements-filter';

@Component({
  selector: 'app-required-documentation',
  templateUrl: './required-documentation.component.html',
  styleUrls: ['./required-documentation.component.scss'],
})
export class RequiredDocumentationComponent implements OnInit, OnDestroy {
  /** USD notional of the operation. */
  @Input() amountUsd = 0;

  matrix: DocumentMatrix | null = null;
  private sub?: Subscription;

  constructor(private readonly documentRequirements: DocumentRequirementsService) {}

  ngOnInit(): void {
    this.sub = this.documentRequirements
      .getMatrixCached()
      .subscribe((matrix) => (this.matrix = matrix));
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  get range(): DocumentRange | null {
    return selectRangeForAmount(this.matrix?.ranges ?? [], this.amountUsd);
  }

  get showSection(): boolean {
    return this.range !== null;
  }

  trackByPersonType(_: number, group: DocumentGroup): string {
    return group.personType;
  }

  formatUsd(value: number): string {
    return value.toLocaleString('en-US', { maximumFractionDigits: 0 });
  }

  svgIconFor(icon: DocumentItemIcon): string {
    return icon === 'person' ? 'person' : 'attach_file';
  }
}
